// extracted by mini-css-extract-plugin
export default {"separator":"styles_separator__8WAK+","campaignNameOverlay":"styles_campaignNameOverlay__JOvBx","customNameButton":"styles_customNameButton__m9pE2","asText":"styles_asText__SWSKk"};